<template>
  <v-dialog
    v-model="showExportModal"
    :scrollable="true"
    max-width="350px "
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="headline">
          <v-icon class="mr-2" :color="onGoingExport ? 'red' : '#FFB822'"
            >fa fa-exclamation-circle</v-icon
          >
          Note
        </span>
      </v-card-title>

      <v-card-text class="mt-3">
        <h5 class="text-center font-weight-normal" v-if="!onGoingExport">
          We are now processing your request. <br /><br />
          The data will be compiled and will be sent to your email.
          <b> This may take time depending on how big the data is.</b>
        </h5>
        <h5 class="text-center font-weight-normal" v-if="onGoingExport">
          <b>You have ongoing export request</b>,<br />
          This may take a while.<br /><br />
          <b> We will send to your email </b> and notify you once finished.
        </h5>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="!onGoingExport">
        <v-btn color="blue-grey" dark @click="close()"> Cancel </v-btn>
        <v-spacer></v-spacer>
        <button class="btn btn-warning" @click="proceed()">
          <i class="fa fa-angle-double-right" style="line-height: 1px" />
          Proceed
        </button>
      </v-card-actions>
      <v-card-actions v-if="onGoingExport">
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" dark @click="close()"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ExportModal',

  props: ['value', 'onGoingExport'],

  data() {
    return {};
  },
  computed: {
    showExportModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    onGoingExport(val) {},
  },
  mounted() {},
  methods: {
    close() {
      this.showExportModal = false;
    },
    proceed() {
      this.$emit('exportProceed', true);
    },
  },
};
</script>
<style lang="stylus">
.unit-modal__table
  width 100%

.v-tab
  white-space unset !important
</style>
